import { ClaimsDetails } from '../models/claimDetailModel';
import * as types from '../types/claimListTypes';

const initialState: ClaimsDetails = {
    claimDetails: {},
};

const claimReducer = (state = initialState, action: any) => {
    switch ( action.type ) {
        case types.SET_CLAIM_DETAILS:
            return {
                ...state,
                claimDetails: {...action.claimDetails},
            };
        default:
            return state;
    }
};

export default claimReducer;
